import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden bg-brand-bg" data-id="element-88">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-start text-left" data-id="element-90">
          <div className="inline-block bg-brand-accent/10 text-brand-accent font-bold px-4 py-1.5 rounded-full text-sm mb-6 uppercase tracking-wider" data-id="element-91">
            El Sistema Anti-Caos
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl leading-[1.1] mb-6 text-brand-dark" data-id="element-92">
            Cena en 15:
            <br data-id="element-93" />
            <span className="text-brand-accent" data-id="element-94">Para Padres Agotados</span>
          </h1>
          <p className="text-lg md:text-xl text-stone-600 mb-8 leading-relaxed font-sans" data-id="element-95">
            Deja de regalar tu dinero al "Drive-Thru" y recupera tus tardes con
            cenas saludables que se arman en menos tiempo del que tarda en
            llegar la pizza.
          </p>

          <div className="w-full sm:w-auto flex flex-col items-center sm:items-start gap-3" data-id="element-96">
            <motion.a href="#buy-now" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full sm:w-auto bg-brand-accent hover:bg-brand-accent-hover text-white font-bold text-lg py-4 px-8 rounded-xl shadow-lg shadow-brand-accent/30 transition-colors text-center animate-pulse-slow" data-id="element-97">
              ¡SÍ, QUIERO CENAR EN 15 MINUTOS!
            </motion.a>
          </div>
        </motion.div>

        <motion.a href="#pricing" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.98
      }} className="relative mx-auto w-full max-w-md md:max-w-full block cursor-pointer" data-id="element-98">
          <div className="absolute inset-0 bg-brand-accent/20 rounded-3xl blur-3xl transform -rotate-6 scale-105" data-id="element-99"></div>
          <img src="https://cdn.magicpatterns.com/uploads/3gDiM7iqatHesZXQXZWcXW/ideogram-v3.0_a_surreal_and_vibrant_cinematic_photo_of_A_premium_digital_product_mockup_featur-0.jpg" alt="Cena en 15 Mockup" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl border border-stone-200/50 object-cover" data-id="element-100" />
        </motion.a>
      </div>
    </section>;
}